<template>
    <div>
        <MenuAccount_Main/>
        <AccountRetrospectList/>
    </div>
</template>

<script>

import MenuAccount_Main from '@/components/menuadmin/account/accountheader/MenuAccount_Main.vue'
import AccountRetrospectList from '@/components/menuadmin/account/accountcreate/AccountRetrospectList.vue'
export default {
    name:'accountRetrospect',
    components:{
        MenuAccount_Main,
        AccountRetrospectList,
    },
}
</script>